import { Capacitor } from '@capacitor/core';

export type BillingPlatform = 'web' | 'electron' | 'capacitor' | 'unknown';

export function isIosInAppPurchasePlatform(): boolean {
  try {
    return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
  } catch {
    return false;
  }
}

export function isNativeBillingPaywallPlatform(): boolean {
  const win = window as { electron?: { iap?: unknown; store?: unknown } };
  if (isIosInAppPurchasePlatform()) return true;
  if (win.electron?.iap) return true;
  if (win.electron?.store) return true;
  return false;
}

export function detectBillingPlatform(): BillingPlatform {
  const win = window as {
    electron?: { isElectron?: boolean };
    Capacitor?: { isNativePlatform?: () => boolean };
  };

  if (win.electron?.isElectron) return 'electron';
  if (win.Capacitor?.isNativePlatform?.()) return 'capacitor';
  if (typeof window !== 'undefined') return 'web';
  return 'unknown';
}

export function isDebugProEnabled(): boolean {
  if (process.env.NODE_ENV === 'production') return false;
  try {
    return new URLSearchParams(window.location.search).get('debugPro') === '1';
  } catch {
    return false;
  }
}
